<div class="container">
  <h3>Users</h3>

  <div class="stats-card">
    <div>
      <div class="counter">{{total}}</div>
      <div class="hint">Total Users</div>

      <div class="infoline">
<!--        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">-->
<!--          <path d="M4.49992 16.6667L3.33325 15.5001L12.9999 5.83341H7.49992V4.16675H15.8333V12.5001H14.1666V7.00008L4.49992 16.6667Z" fill="#00FF22"/>-->
<!--        </svg>-->

<!--        28-->

<!--        <span>+2.1 % this week</span>-->
      </div>

    </div>
  </div>

  <div class="table-toolbar">
    <app-icon-input [formControl]="searchValue" placeholder="Search by name" style="width: 300px"></app-icon-input>


  </div>

  @if(store.isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class="table-container mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort matSortActive="date" matSortDisableClear matSortDirection="desc" (matSortChange)="sortChange($event)">

      <!-- Name Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell *matCellDef="let row"> {{row.email}} </td>
      </ng-container>

      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
        <td mat-cell *matCellDef="let row"> {{row.firstName }} </td>
      </ng-container>

      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
        <td mat-cell *matCellDef="let row"> {{row.lastName }} </td>
      </ng-container>
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Created At </th>
        <td mat-cell *matCellDef="let row"> {{row.createdAt | date : 'MM/dd/yyyy' }} </td>
      </ng-container>

      <ng-container matColumnDef="subscriptionStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Subscription </th>
        <td mat-cell *matCellDef="let row"> {{row.subscriptionStatus}} </td>
      </ng-container>

      <ng-container matColumnDef="isApproved">
        <th mat-header-cell *matHeaderCellDef  mat-sort-header> Approved </th>
        <td mat-cell *matCellDef="let row">
          <mat-slide-toggle [checked]="row.isApproved" (change)="approve($event.checked, row.id)" class="thin-toggle"></mat-slide-toggle>
        </td>
      </ng-container>
      <ng-container matColumnDef="isRejected">
        <th mat-header-cell *matHeaderCellDef  mat-sort-header> Rejected </th>
        <td mat-cell *matCellDef="let row">
          @if (row.isRejected) {
            <span class="warning">Yes</span>
          } @else {
            <span>No</span>
          }
        </td>
      </ng-container>


      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="w-15p"></th>
        <td mat-cell *matCellDef="let row">
          <mat-icon (click)="openDialog(row)" class="pointer mt-5 mr-5">edit</mat-icon>
          @if (!row.isRejected) {
            <mat-icon (click)="rejectUser(row.id, true)" class="pointer warning mt-5 mr-5">cancel</mat-icon>
          } @else {
            <mat-icon (click)="rejectUser(row.id, false)" class="pointer mt-5 mr-5">check_circle</mat-icon>
          }
          <mat-icon (click)="delete(row.id)" class="pointer warning mt-5">delete_forever</mat-icon>

        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

    <app-custom-paginator [total]="total" (pageChanged)="changePage($event)"></app-custom-paginator>


  </div>

</div>

